import React, { useState } from 'react';
import { BlockBar, BlockBarButton } from '../BlockBar';
import { Icons } from '../../../components/atoms/SVG';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { CheckBoxParam, SonForm } from '../../Form2';
import { useDelayed } from '../../../hooks/useDelayed';
import { useRefreshView } from '../../ViewFetcher';
import {
  DryRunAcceptDeclineForm,
} from '../../Form2/standardForms/AcceptDeclineForm/DryRunAcceptDeclineForm';

type ReportsListActionBarProps = {
  form: SonForm<CheckBoxParam<'dryRun'>>;
  heading: string;
  headline: string;
  messageSuccess: string;
  messageSending: string;
  messageFail: string;
  customErrorTypeMessages?: Record<string, string>;
  hintMessage?: string;
  checkBoxLabel: string;
};

/**
 * Provides a bar to be displayed above the list of membership matching reports
 * that allows to trigger or dry-run the membership matcher manually
 */
export function ReportsListActionBar({
  form,
  heading,
  headline,
  messageSuccess,
  messageSending,
  messageFail,
  customErrorTypeMessages,
  hintMessage,
  checkBoxLabel,
}: ReportsListActionBarProps) {
  const { refreshView } = useRefreshView();
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
    refreshView();
  };
  const delayedCloseModal = useDelayed(closeModal);

  return (
    <>
      <BlockBar heading={heading} hierarchy={3} modifier="border-bottom">
        <BlockBarButton
          text={heading}
          svgSpriteId={showModal ? Icons.DECLINE_CROSS : Icons.AUTOMATIC}
          onClick={() => setShowModal(true)}
        />
      </BlockBar>
      {showModal
        ? (
            <ModalDialog headline={heading} closeModal={closeModal} initialFocusIndex={1}>
              <DryRunAcceptDeclineForm
                form={form}
                onSuccess={delayedCloseModal}
                headline={headline}
                messageSuccess={messageSuccess}
                messageSending={messageSending}
                messageFail={messageFail}
                customErrorTypeMessages={customErrorTypeMessages}
                hintMessage={hintMessage}
                checkBoxLabel={checkBoxLabel}
              />
            </ModalDialog>
          )
        : null}
    </>
  );
}
